import FormGroup from '../../formComponents/FormGroup'
import FormValue from '../../formComponents/FormValue'
import InputField from '../../formComponents/InputField'
import TextareaField from '../../formComponents/TextareaField'

type SeoSettingsPanelProps = {
  previewPageTitle: string
} & TranslateProps

export default function SeoSettingsPanel({ previewPageTitle, t }: Readonly<SeoSettingsPanelProps>) {
  return (
    <>
      <FormValue key="titleTag" name="titleTag">
        {(titleTagValue) => (
          <FormGroup
            name="titleTag"
            tagName="label"
            label={t('titleTagInputField.label')}
            info={t('titleTagInputField.explanation')}
            meta={t('characterCounter', {
              characters: titleTagValue.length,
              maxCharacters: 70,
            })}
          >
            <InputField name="titleTag" type="text" placeholder={previewPageTitle} maxLength="70" />
          </FormGroup>
        )}
      </FormValue>
      <FormValue key="metaDescription" name="metaDescription">
        {(metaDescriptionValue) => (
          <FormGroup
            name="metaDescription"
            tagName="label"
            label={t('metaDescriptionInputField.label')}
            info={t('metaDescriptionInputField.explanation')}
            meta={t('characterCounter', {
              characters: metaDescriptionValue.length,
              maxCharacters: 160,
            })}
          >
            <TextareaField name="metaDescription" maxLength="160" />
          </FormGroup>
        )}
      </FormValue>
    </>
  )
}
